import StencilHTMLElement from "./stencil-element";

class DiscountkitGwpPicker extends StencilHTMLElement {
  name = "DiscountkitGwpPicker";

  isTestCustomer = document.querySelector("body").dataset.testCustomer === "true";
  currentMarket = document.querySelector("body").dataset.market;

  data;
  modal;
  selectedVariantId;
  openButton;
  addButton;
  discountId;
  config;
  mode;

  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback?.();
    console.log(this.logPrefix, "connectedCallback");

    this.discountId = this.getAttribute("discount-id");
    this.modal = window.bootstrap.Modal.getOrCreateInstance(this.querySelector(".modal"));
    this.mode = this.getAttribute("mode") || "button"; // Default to button mode if not specified

    try {
      this.data = JSON.parse(atob(this.getAttribute("data"))) || {};
    } catch (e) {
      console.error(this.logPrefix, "Failed to parse GWP data", e);
      this.data = {};
    }
    this.removeAttribute("data");

    this.config = this.data.discountNode.config.value;

    this.addButton = this.querySelector(".discountkit-gwp-add-button");
    this.addButton.addEventListener('click', this.onAddButtonClick.bind(this));

    this.declineButton = this.querySelector(".discountkit-gwp-decline-button");
    this.declineButton.addEventListener('click', this.onDeclineButtonClick.bind(this));

    this.openButton = this.querySelector(".discountkit-gwp-open-button");
    if (this.openButton) {
      this.openButton.addEventListener('click', () => {
        if (this.mode === "button") {
          console.log(this.logPrefix, "Opening GWP modal from button click");
          this.modal.show();
        } else {
          console.warn(this.logPrefix, "Open button clicked but not in button mode, ignoring");
        }
      });
    }

    this.spinner = this.querySelector(".loading-spinner");

    this.options = this.querySelectorAll("input[name='selected-variant']");
    this.options.forEach(option => {
      option.addEventListener('change', e => {
        this.selectedVariantId = e.target.value;
        this.addButton.disabled = false;
      });
    });

    this.products = this.querySelectorAll(".discountkit-gwp-product");
    this.products.forEach(product => {
      // Add a click handler to select the variant when the product is clicked
      product.addEventListener('click', e => {
        const input = product.querySelector("input[name='selected-variant']");
        if (input) {
          input.checked = true;
          input.dispatchEvent(new Event('change')); // Trigger change event to update selectedVariantId
        }
      });
    });

    // When should show? VARIES WILDLY based on the discount config.
    document.addEventListener('cart-watcher:changed', this.onCartChange.bind(this));

    console.log(this.logPrefix, "Discount data", this.data);
  }

  onCartChange(e) {
    console.log(this.logPrefix, "Cart changed", e.detail);
    this.updateState(e.detail);
    if(this.shouldShow(e.detail)) {
      if(this.mode === "button") {
        console.log(this.logPrefix, "Showing GWP button");
        // Show the button if in button mode
        if (document.startViewTransition) {
          document.startViewTransition(() => {
            this.openButton.classList.remove("d-none");
          });
        } else {
          this.openButton.classList.remove("d-none");
        }
      } else {
        if(!this.modal._isShown && !this.modal._isTransitioning) {
          console.log(this.logPrefix, "Showing GWP modal");
          this.modal.show();
        } else {
          console.log(this.logPrefix, "GWP modal already showing");
        }
      }
    } else {
      this.modal.hide();
      // Hide the button if in button mode
      if (document.startViewTransition) {
        document.startViewTransition(() => {
          this.openButton.classList.add("d-none");
        });
      } else {
        this.openButton.classList.add("d-none");
      }
    }
  }

  updateState(cartDiff) {
    // TODO: Properly update the state based on the cartDiff.

    // For now, if the cart is cleared, we reset the state. What we should
    // actually do is store WHAT was added to the cart, and then properly set
    // the state based on that.
    const state = localStorage.getItem(`discountkit-gwp:${this.discountId}`);
    if(cartDiff.newCart.item_count === 0) {
      console.log(this.logPrefix, "Cart is empty, previous actions void, reset state");
      localStorage.removeItem(`discountkit-gwp:${this.discountId}`);
    }
  }

  shouldShow(cartDiff) {
    // Check localStorage for a flag to skip this GWP if dismissed
    if(localStorage.getItem(`discountkit-gwp:${this.discountId}`) === "declined") {
      console.log(this.logPrefix, "Skipping GWP for declined discount ID:", this.discountId);
      return false;
    }

    // Check localStorage for a flag to skip this GWP if already added
    if(localStorage.getItem(`discountkit-gwp:${this.discountId}`) === "added") {
      console.log(this.logPrefix, "Skipping GWP for already added discount ID:", this.discountId);
      return false;
    }

    // Check if discount in test mode and not a test customer
    if(this.config.test && !this.isTestCustomer) {
      console.log(this.logPrefix, "Skipping GWP for non-test customer");
      return false;
    }

    // Check if current market is eligible. Backup, as it shouldn't even be
    // output in Liquid if market doesn't match.
    if(this.config.marketOperator === "oneOf" && !this.config.marketHandles.includes(this.currentMarket)) {
      console.log(this.logPrefix, "Skipping GWP for market:", this.currentMarket, "not in", this.config.marketHandles);
      return false;
    }
    if(this.config.marketOperator === "notOneOf" && this.config.marketHandles.includes(this.currentMarket)) {
      console.log(this.logPrefix, "Skipping GWP for market:", this.currentMarket, "in", this.config.marketHandles);
      return false;
    }

    // Check the tiers
    // FIXME: Only currently checking a single tier.
    const tier = this.config.tiers[0];
    switch(tier.buys.type){
      // FIXME: Only handling the minimumSubtotal case for now.
      case "minimumSubtotal":
        const subtotal = cartDiff.newCart.total_price;
        if(subtotal < tier.buys.value) {
          console.log(this.logPrefix, "Skipping GWP for subtotal:", subtotal, "less than required:", tier.buys.value);
          return false;
        }
        break;
      default:
        console.warn(this.logPrefix, "Unknown buys type:", tier.buys.type);
        return false;
    }

    return true;
  }

  async onAddButtonClick(e) {
    if (!this.selectedVariantId) {
      console.warn(this.logPrefix, "No variant selected");
      return;
    }

    console.log(this.logPrefix, "Adding GWP with variant ID:", this.selectedVariantId);

    this.spinner.classList.remove("d-none");

    const result = await MP.Extensions.Cart.add({
      id: this.selectedVariantId,
      quantity: 1,
      properties: {
        "_discountkit-gwp": this.discountId,
      }
    });

    localStorage.setItem(`discountkit-gwp:${this.discountId}`, "added"); // set localStorage to skip this GWP in future
    this.spinner.classList.add("d-none");
    this.modal.hide();

    // Hide the button if in button mode
    if (document.startViewTransition) {
      document.startViewTransition(() => {
        this.openButton.classList.add("d-none");
      });
    } else {
      this.openButton.classList.add("d-none");
    }

  }

  onDeclineButtonClick(e) {
    console.log(this.logPrefix, "Declining GWP");
    localStorage.setItem(`discountkit-gwp:${this.discountId}`, "declined"); // set localStorage to skip this GWP in future
    this.modal.hide();
    // Hide the button if in button mode
    if (document.startViewTransition) {
      document.startViewTransition(() => {
        this.openButton.classList.add("d-none");
      });
    } else {
      this.openButton.classList.add("d-none");
    }
  }
}

export default DiscountkitGwpPicker;